<template>
    <div v-if="dataIsLoaded">
        <div class="px-[3.75rem] pt-[2.5rem] pb-[3.125rem] bg-white rounded-md absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2">
            <h1 class="text-center text-2xl mb-8">Войти как</h1>
            <div class="flex items-center gap-4">
                <div @click="goLikeFounder" class="cursor-pointer w-[190px] bg-[#F4F6FA] hover:bg-[#eceff4] flex flex-col items-center gap-4 py-5 px-4 rounded">
                    <svg class="w-[3.75rem] h-[3.75rem]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61 63" fill="none"><path d="M25.9699 2.18993L11 7.79992C7.54997 9.08992 4.72998 13.1699 4.72998 16.8599V39.1499C4.72998 42.6899 7.07001 47.3399 9.92001 49.4699L22.82 59.0999C27.05 62.2799 34.0099 62.2799 38.2399 59.0999L51.14 49.4699C53.99 47.3399 56.3299 42.6899 56.3299 39.1499V16.8599C56.3299 13.1699 53.5099 9.08992 50.0599 7.79992L35.09 2.18993C32.54 1.25993 28.4599 1.25993 25.9699 2.18993Z" stroke="#4A6B96" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M30.4996 28.2603C30.3796 28.2603 30.2296 28.2603 30.1096 28.2603C27.2896 28.1703 25.0396 25.8302 25.0396 22.9802C25.0396 20.0702 27.4096 17.7002 30.3196 17.7002C33.2296 17.7002 35.5996 20.0702 35.5996 22.9802C35.5696 25.8602 33.3196 28.1703 30.4996 28.2603Z" stroke="#4A6B96" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M24.5296 36.6603C21.6496 38.5803 21.6496 41.7303 24.5296 43.6503C27.7996 45.8403 33.1696 45.8403 36.4396 43.6503C39.3196 41.7303 39.3196 38.5803 36.4396 36.6603C33.1996 34.4703 27.8296 34.4703 24.5296 36.6603Z" stroke="#4A6B96" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    <p style="color: #4A6B96;">Владелец компании</p>
                </div>
                <div @click="goLikeStaff" class="cursor-pointer w-[190px] bg-[#F4F6FA] hover:bg-[#eceff4] flex flex-col items-center gap-4 py-5 px-4 rounded">
                    <svg class="w-[3.75rem] h-[3.75rem]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58 58" fill="none"><path d="M29.2899 30.8848C29.1207 30.8607 28.9032 30.8607 28.7099 30.8848C24.4566 30.7398 21.0732 27.2598 21.0732 22.9823C21.0732 18.6082 24.6016 15.0557 28.9999 15.0557C33.3741 15.0557 36.9266 18.6082 36.9266 22.9823C36.9024 27.2598 33.5432 30.7398 29.2899 30.8848Z" stroke="#4A6B96" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/><path d="M45.2881 46.835C40.9864 50.7742 35.2831 53.1667 28.9998 53.1667C22.7164 53.1667 17.0131 50.7742 12.7114 46.835C12.9531 44.5634 14.4031 42.34 16.9889 40.6C23.6106 36.2017 34.4373 36.2017 41.0106 40.6C43.5964 42.34 45.0464 44.5634 45.2881 46.835Z" stroke="#4A6B96" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/><path d="M29.0002 53.1668C42.347 53.1668 53.1668 42.347 53.1668 29.0002C53.1668 15.6533 42.347 4.8335 29.0002 4.8335C15.6533 4.8335 4.8335 15.6533 4.8335 29.0002C4.8335 42.347 15.6533 53.1668 29.0002 53.1668Z" stroke="#4A6B96" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    <p style="color: #4A6B96;">Сотрудник</p>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <LoadingComponent />
    </div>
</template>


<script>
    import { mapState } from 'vuex';

    import LoadingComponent from '@/components/LoadingComponent.vue';

    export default {
        name: "ChooceRole",
        components: {
            LoadingComponent,
        },
        computed: {
            ...mapState(["companyData", "role"]),
        },
        data() {
            return {
                dataIsLoaded: true,
            }
        },
        methods: {
            async goLikeFounder() {
                this.dataIsLoaded = false; 
                await this.$store.dispatch("setRoleData", "founder");
                let result = await this.$store.dispatch("fetchCompanyData");
                if (result.detail == "redirect_to_choose_role") {
                    this.$router.push({name: "role"})
                }
                if (result.successfully && this.companyData) {
                    if (result.successfully) { result = await this.$store.dispatch("fetchKassas"); }
                    if (result.successfully) { result = await this.$store.dispatch("fetchProfileData"); }
                    if (result.successfully) { result = await this.$store.dispatch("fetchClients"); }
                    if (result.successfully) { result = await this.$store.dispatch("fetchGoods"); }
                    if (result.successfully) { result = await this.$store.dispatch("fetchSupplyingsAndMovings"); }
                    if (result.successfully) { result = await this.$store.dispatch("fetchStaffs"); }
                    if (this.companyData.plan.schedule_and_salary_plugin_is_active) {
                        if (result.successfully) { result = await this.$store.dispatch("fetchSchedules", {dateFrom: this.$globalMethods.getFirstDayOfCurrentMonth(), dateTo: this.$globalMethods.getFirstDayOfCurrentMonth()}); }
                        if (result.successfully) { result = await this.$store.dispatch("fetchPayouts", {targetPeriod: this.$globalMethods.getFirstDayOfCurrentMonth()}); }
                        if (result.successfully) { result = await this.$store.dispatch("fetchSalaryReports", this.$globalMethods.getFirstDayOfCurrentMonth()); }
                    }
                    if (result.successfully) { this.dataIsLoaded = true; this.$router.push({ name: 'dashboard' }); }
                } else {
                    this.$router.push({ name: 'create-company' });
                }
            },
            async goLikeStaff() {
                this.dataIsLoaded = false;
                await this.$store.dispatch("setRoleData", "staff");
                await this.$store.dispatch("fetchAvailableCompanies");
                this.dataIsLoaded = true;
                this.$router.push({ name: 'choose-company' });
            },
        }
    }
</script>